var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"web-component-bg\"> <div class=\"page-header-image\" ng-style=\"{ 'background-image': 'url(' + ($ctrl.image || '') + ')' }\"> <div class=\"web-component-center\"> <div class=\"page-header-info\"> <h1 class=\"title\" ng-if=\"$ctrl.title\">{{ $ctrl.title }}</h1> <p class=\"subtitle\" ng-if=\"$ctrl.subtitle\">{{ $ctrl.subtitle }}</p> </div> </div> </div> </div>";
var id1="pageHeader.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/pageHeader/pageHeader.html
// module id = 347
// module chunks = 2